<template>
  <div class="header-dots" v-if="shortcutItems.length > 1">
    <span slot="button-content">
      <q-btn
        flat
        dense
        round
        color="white"
        class="toptabshort"
        icon="launch">
        <q-tooltip anchor="center left" self="center right">
          사이트 즐겨찾기
        </q-tooltip>
        <q-menu 
          anchor="bottom left" 
          self="top middle" 
          auto-close
          transition-show="jump-down"
          transition-hide="jump-up">
          <q-list class="topMenuShort">
            <q-item clickable v-ripple v-for="tag in shortcutItems"
              :key="tag.shortcutId"
              :name="tag.title"
              ref="tag"
              @click="setShortcut(tag)">
              <q-item-section>
                <q-item-label lines="1">{{tag.title}}</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-menu>
      </q-btn>
    </span>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  components: {
  },
  data() {
    return {
      shortcutItems: [],
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    init() {
      this.$http.url = selectConfig.sys.shortcut.list.url;
      this.$http.type = 'GET';
      this.$http.param = {useFlag: 'Y'};
      this.$http.request((_result) => {
        this.shortcutItems = _result.data;
      },);
    },
    setShortcut(_tag) {
      window.open(_tag.url,'','')
    },
  }
};
</script>
<style lang="sass">
.topMenuShortDropdown
  padding-top: 0px !important
  padding-bottom: 0px !important
.toptabshort
  width: 26px
  height: 26px
  margin-right: 10px
  i
    margin-top: -8px
    margin-left: -6px
.topMenuShort
  min-width: 200px
  max-height: 289px
  *:hover
    text-decoration: none
  i
    font-size: 11px !important
  .q-item__label
    padding-left: 10px
</style>
